/* eslint formatjs/no-literal-string-in-jsx: "error" */
import { RoundedRectangle } from "../atoms/roundedrectangle/RoundedRectangle"
import React from "react"
import { RRIconBar } from "../atoms/roundedrectangle/RRIconBar"
import { BodySmall } from "../atoms/Bodies"
import { FormattedMessage } from "react-intl"

export const CarrotExpertsModule = () => (
  <RoundedRectangle backgroundColor="light-gray">
    <RRIconBar iconName="icn-help" iconBackgroundColor="white" />
    <BodySmall color="black-60">
      <FormattedMessage defaultMessage="Carrot resources are for informational purposes only and do not constitute medical advice or professional services. They are not a substitute for legal, tax, or professional medical advice, diagnosis, or treatment. If you are experiencing a medical emergency, call emergency services immediately." />
    </BodySmall>
  </RoundedRectangle>
)
